export default __webpack_public_path__ + "static/media/6e0e880b836fc9d0e6f27f2ceb02fabf.svg";